import React from "react";
import {selectModeData} from "../../../redux/selectors/editor";
import {IGraphData, UpdateModeData, updateModeData} from "../../../redux/slices/editor";
import {connect} from "react-redux";
import ModeMenu from "./ModeMenu";

interface IGraphMenu {
    graphData: IGraphData
    onClose: () => void
    open: boolean
    parent: HTMLElement
    updateModeData: UpdateModeData
}
function GraphMenu({parent, graphData, onClose, open, updateModeData}: IGraphMenu) {
    const menu = [
        {
            onClick: () => updateModeData({showMiniMap: ! graphData.showMiniMap}),
            text: "Toggle MiniMap",
            tick: graphData.showMiniMap,
            title: "Show the draggable minimap on the graph screen",
        },
        {
            onClick: () => updateModeData({quickViewEnabled: ! graphData.quickViewEnabled}),
            text: "Toggle Script Quick View",
            tick: graphData.quickViewEnabled,
            title: "Script quick view hovers a larger script window " +
                "over a state when the mouse goes over the script text"
        },
        {
            onClick: () => updateModeData({graphLayout: graphData.graphLayout === "script" ? "actions" : "script"}),
            text: "Toggle Script View",
            tick: graphData.graphLayout === "script",
            title: "Script the script in the state node rather than the actions"
        },
        {
            onClick: () => updateModeData({lockedStates: ! graphData.lockedStates}),
            text: "Toggle Locked States",
            tick: graphData.lockedStates,
            title: "When set you are not able to move state nodes"
        },
        {
            onClick: () => updateModeData({events: ["rearrangeStates"]}),
            text: "Rearrange Nodes",
            tick: false,
            title: "Rearrange the node positions automatically"
        },
        {
            onClick: () => updateModeData({useCookbookPositions: !graphData.useCookbookPositions}),
            text: "Use cookbook Positions",
            tick: Boolean(graphData.useCookbookPositions),
            title: "When set node positions will match the Cookbook flow"
        },
        {
            onClick: () => updateModeData({touchMode: ! graphData.touchMode}),
            text: "Enable Touch Mode",
            tick: graphData.touchMode,
            title: "Switch the graph to use touch mode for panning and zooming"
        },
        {
            onClick: () => updateModeData({events: ["exportGraph"]}),
            text: "Export Graph",
            title: "Export the graph as an image"
        }
    ]

    return (
        <ModeMenu menu={menu} open={open} onClose={onClose} parent={parent}/>
    );
}
const mapStateToProps = (store: never) => ({
    graphData: selectModeData(store) as IGraphData,
});
export default connect(mapStateToProps, {
    updateModeData,
})(GraphMenu);
